module.exports = __webpack_public_path__ + "static/media/FODL.68064d2b.png";